module.exports = __webpack_public_path__ + "partly_sunny_icon.png";